export default __webpack_public_path__ + "static/media/es-safemars-whitepaper.401c9b45.pdf";